import {
  Component,
  ModuleWithProviders,
  NgModule,
  ViewEncapsulation,
  ElementRef,
  OnDestroy,
  Directive,
  Input,
  HostBinding,
  ChangeDetectionStrategy
} from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LyTheme } from './theme.service';
import { ThemeModule } from './theme/theme.module';
import { Platform } from './platform/index';

const id = 0;

@Component({
  selector: 'ly-core[root]',
  template: `
  <ng-content></ng-content>
  `,
  styles: ["html, body { width: 100%; height: 100%; } body { margin: 0; } ly-core[root] { display: block; position: relative; } ly-svg svg, [ly-svg] svg { width: inherit; height: inherit; fill: currentColor; display: block; } @keyframes btnFocusAnim { from { transform: scale(0.6); } 50% { transform: scale(0.8); } to { transform: scale(0.6); } } [ly-ripple] > ly-hover-container { position: absolute; top: 0; left: 0; background: currentColor; opacity: 0; transform: scale3d(0, 0, 0); transition: all 0ms cubic-bezier(0.45, 0, 0.25, 1); border-radius: 100%; } button { -webkit-tap-highlight-color: transparent; } [ly-icon-button] > .ly-icon-button-container > .ly-icon-button-content > ly-hover-container { background: -moz-radial-gradient(center, ellipse cover, currentColor 0%, transparent 100%); /* FF3.6-15 */ background: -webkit-radial-gradient(center, ellipse cover, currentColor 0%, transparent 100%); /* Chrome10-25,Safari5.1-6 */ background: radial-gradient(ellipse at center, currentColor 0%, transparent 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */ } [ly-ripple]:not(.ly-ripple-no-focus):focus > ly-hover-container, [ly-button]:not(.ly-ripple-no-focus):focus > .ly-button-ripple > ly-hover-container { animation: btnFocusAnim infinite 1.4s 0ms; transform: scale3d(1, 1, 1); opacity: .13; } [ly-icon-button]:not(.ly-ripple-no-focus):focus > .ly-icon-button-container > [ly-ripple] > ly-hover-container { /* for ly-icon-button*/ transform: scale3d(1, 1, 1); opacity: .33; transition: all 375ms cubic-bezier(0.45, 0, 0.25, 1); } /* LyRippleMinimal */ .ly-ripple-minimal { position: relative; } .ly-ripple-minimal .ly-ripple-container { position: absolute; width: 5px; height: 5px; background: currentColor; opacity: .16; border-radius: 100%; transform: scale(0); transition: opacity ease, transform cubic-bezier(0.4, 0, 0.2, 1); pointer-events: none; } ly-drawer-container { display: flex; } ly-drawer-container .ly-drawer { position: fixed; overflow: auto; height: inherit; width: inherit; top: inherit; bottom: inherit; text-align: inherit; } ly-drawer-container ly-drawer-content { flex: 1 1; } "],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false
})
export class LyRoot implements OnDestroy {
  @HostBinding('style.background') backgroundStyle: string;
  @HostBinding('style.color') colorStyle: string;
  @HostBinding('style.font-family') fontFamily: string;
  themeSubscription: Subscription;
  constructor(private elementRef: ElementRef, private theme: LyTheme) {
    this.themeSubscription = this.theme.palette.subscribe((palette) => {
      this.backgroundStyle = palette['bgText'];
      this.colorStyle = palette['colorText'];
      this.fontFamily = theme.AlyleUI.currentTheme.typography.fontFamily;
    });
  }
  ngOnDestroy() {
    this.themeSubscription.unsubscribe();
  }
}
@Component({
  selector: 'inline-text',
  template: `<ng-content></ng-content>`,
  styles: [`
    :host {
      vertical-align: baseline;
    }
  `],
})
export class LyInlineText {}

@NgModule({
  imports: [CommonModule],
  exports: [LyRoot, LyInlineText],
  declarations: [LyRoot, LyInlineText],
  providers: [Platform]
})
export class LyCoreModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: LyCoreModule,
    };
  }
}
